/**
 * Single source of truth for company / legal details surfaced across the
 * footer, contact, privacy, and terms pages. Update these constants in one
 * place. Items marked TODO should be confirmed against official records
 * (Companies House registration number, registered office, DPO contact).
 */
export const COMPANY = {
  /** Trading / brand name shown in the footer copyright. */
  groupName: 'Mustardtree Group',
  /** Legal entity behind the platform. */
  legalName: 'MustardTree Partners',
  /** The product this app provides. */
  product: 'ESGDash',
  tagline: 'Governance, Intelligence & Advisory',
  description:
    'MustardTree Partners delivers corporate governance, strategic intelligence, and data-driven advisory for ambitious organisations.',
  website: 'https://mustardtreegroup.com',
  /** Primary contact address. TODO: confirm the correct inbox. */
  email: 'hello@mustardtreegroup.com',
  /** Privacy / data-protection contact. TODO: confirm. */
  privacyEmail: 'privacy@mustardtreegroup.com',
  jurisdiction: 'England & Wales',
  /** TODO: add the registered company number once confirmed. */
  companyNumber: '',
  /** TODO: add the registered office address once confirmed. */
  registeredAddress: '',
} as const;

/** First year of operation, used to anchor the copyright range. */
export const COPYRIGHT_START_YEAR = 2024;

/**
 * Build an auto-updating copyright line, e.g. "© 2024–2026 Mustardtree Group".
 * Collapses to a single year until the year actually rolls over.
 */
export function copyrightLine(now: Date = new Date()): string {
  const year = now.getFullYear();
  const span = year > COPYRIGHT_START_YEAR ? `${COPYRIGHT_START_YEAR}–${year}` : `${year}`;
  return `© ${span} ${COMPANY.groupName}. All rights reserved.`;
}
